import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { convertDataToCSV } from '@careerstart/wae-common/src/main/constants/exports-csvs/export';

import ExportView from '../../../../components/ExportViewV2/ExportView';
import { EXPORT_API_PATH, EXPORT_COLUMNS, EXPORT_FILE_NAMES } from '../../timekeepingConstants';

import { getSetData } from './helpers';

const TimekeepingExport = ({ filters, user, activeExport, onClose }) => {
  const [progress, setProgress] = useState(0);

  return (
    <ExportView
      isOpen={!!activeExport}
      onClose={onClose}
      getSetData={() =>
        getSetData({
          apiPath: EXPORT_API_PATH[activeExport],
          filters,
          pageSize: 25,
          token: user?.token,
          setProgress,
        })
      }
      resultToCSVTextConverter={(grid) =>
        convertDataToCSV(grid, EXPORT_COLUMNS[activeExport]) || grid
      }
      fileName={EXPORT_FILE_NAMES[activeExport]}
      setProgress={(newProgress) => setProgress(newProgress)}
      progress={progress}
    />
  );
};

TimekeepingExport.propTypes = {
  onClose: PropTypes.func,
  user: PropTypes.shape({
    role: PropTypes.string,
    token: PropTypes.string,
  }),
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  activeExport: PropTypes.string.isRequired,
};
export default TimekeepingExport;
